// src/hooks/useApi.js
const BASE_URL = 'https://kirtepan-backend-5f2b71eaf03c.herokuapp.com';

export default function useApi() {
    const token = localStorage.getItem('token');

    const request = async (url, method = 'GET', body = null, customHeaders = {}) => {
        try {
            const headers = {
                'Content-Type': 'application/json',
                ...(token && { Authorization: `Bearer ${token}` }),
                ...customHeaders,
            };

            const options = {
                method,
                headers,
            };

            if (body) {
                options.body = JSON.stringify(body);
            }

            const res = await fetch(BASE_URL + url, options); // ✅ BASE_URL eklendi

            if (res.status === 204) return null;

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.message || 'Sunucu hatası');
            }

            return data;
        } catch (err) {
            console.error(`[API Hatası] ${method} ${url}:`, err.message);
            throw err;
        }
    };

    return { request };
}
